<template>
  <div id="app">
    <Header v-if="hideHeader" />
    <router-view></router-view>
  </div>
</template>

<script>
import Header from "@/components/header";
import ShortCutKeys from "@/mixins/ShortCutKeys";

export default {
  name: "POS",
  mixins: [ShortCutKeys],
  components: {
    Header,
  },
  created: function () {
    // if (this.$router.history.current.name != "Login") {
    // this.fetchAllShortCuts();
    // }
  },
  computed: {
    hideHeader: function () {
      if (this.$route.meta.header) return this.$route.meta.header;
      return false;
    },
  },
};

// Disable all the console.log
// console.log = function () {
  
// };

// for (let func in console) {
//   console[func] = function () {
    
//   };
// }

</script>

<style>
@import "~bootstrap/dist/css/bootstrap.css";
@import "~bootstrap-vue/dist/bootstrap-vue.css";

/* CSS */
html,
body {
  height: 100%;
}

#app {
  height: 100%;
}
</style>
